<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item>
            <el-button type="primary" @click="OpenPort">打开串口</el-button>
            <el-button type="primary" @click="ClosePort">关闭串口</el-button>
            <el-button type="primary" @click="CheckJigou">机构检测</el-button>
            <el-button type="primary" @click="CheckVoice">语音检测</el-button>
            <el-button type="primary" @click="QueryCurRange">询问当前区间</el-button>
            <el-button type="primary" @click="SetUserId">设置用户ID</el-button>
            <el-button type="primary" @click="QueryUserId">查询用户ID</el-button>
            <el-button type="primary" @click="SetDiopter">设置屈光度</el-button>
            <el-button type="primary" @click="QueryCpuId">查询芯片ID</el-button>
            <el-button type="primary" @click="SetAuthorizationCode">设置授权码</el-button>
            <el-button type="primary" @click="QueryUserTime">查询用户时长</el-button>
            <el-button type="primary" @click="ClearUserTime">清空用户时长</el-button>
            <el-button type="primary" @click="SetSn">设置产品设备号</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="RslEvLogin">登录</el-button>
            <el-button type="primary" @click="RslEvLoginPrint">打印登录信息</el-button>
            <el-button type="primary" @click="RslEvGetUser">查询用户</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
      </el-tab-pane>
      <!-- 清单列表 end -->
      <el-card class="box-card">
        <div class="title mt20">数据显示区</div>
        <li>关键词：{{ua}}</li>
        <li>电压：{{vol}}</li>
        <li>串口数据：{{portData}}</li>
        <li>电机1：{{portDataDianJi1}}</li>
        <li>电机2：{{portDataDianJi2}}</li>
        <li>电机3：{{portDataDianJi3}}</li>
        <li>电机4：{{portDataDianJi4}}</li>
        <li>光线强度：{{portDataLight}}</li>
        <li>距离：{{portDataDistance}}</li>
        <li>当前区间：{{portDataCurRangeIndex}}</li>
        <li>芯片ID：{{cpuId}}</li>
        <li>选择的服务器用户ID：{{serverUserId}}</li>
        <li>查询到的设备用户ID：{{deviceUserId}}</li>
        <li>查询到的设备屈光度：{{deviceDiopter}}</li>
        <li>授权码结果：{{aCodeResult}}</li>
        <li>用户时长：{{userTime}}</li>
        <li>设备时长：{{deviceTime}}</li>
      </el-card>
  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyRiChang1',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        filename: '',
        fileinfo: ''
      },
      editForm: {
        caiwureportid: '0',
        filename: '',
        fileinfo: ''
      },
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      displayEdit: false,
      filetype: 4,
      btnTitle: '查询',
      //
      ua: 'ua',
      portData: '',
      portDataDianJi1: '',
      portDataDianJi2: '',
      portDataDianJi3: '',
      portDataDianJi4: '',
      portDataLight: '',
      portDataDistance: '',
      portDataCurRangeIndex: '',
      cpuId: 'F51FC4F40CC739',
      serverUserId: '00017499',
      deviceUserId: '',
      userTime: '',
      deviceTime: '',
      vol: '',
      //
      serverDiopter: '-500',
      deviceDiopter: '',
      sn: '0123',
      aCodeResult: ''
    }
  },
  mounted () {
    window.RecvDataFromWinForm = this.RecvDataFromWinForm
    this.GetKeyWord()
  },
  methods: {
    /// /////
    // 获取关键词
    GetKeyWord () {
      this.ua = window.external.GetKeyWord()
    },
    // 打开串口
    OpenPort () {
      window.external.OpenPort('COM4')
    },
    // 关闭串口
    ClosePort () {
      window.external.ClosePort()
    },
    // 机构检测
    CheckJigou () {
      window.external.WritePortData('240A010101')
    },
    // 语音检测
    CheckVoice () {
      window.external.WritePortData('240C010101')
    },
    // 询问当前区间
    QueryCurRange () {
      window.external.WritePortData('2405010101')
    },
    // 设置用户ID
    SetUserId () {
      var data = '240104' + this.serverUserId + '00'
      window.external.WritePortData(data)
    },
    // 查询用户ID
    QueryUserId () {
      window.external.WritePortData('2404010101')
    },
    // 设置屈光度
    SetDiopter () {
      var hex = window.external.IntToHexStr(this.serverDiopter)
      var data = '240202' + hex + '00'
      window.external.WritePortData(data)
    },
    // 查询CPU ID
    QueryCpuId () {
      window.external.WritePortData('2406010101')
    },
    // 设置授权码
    SetAuthorizationCode () {
      var crc16 = window.external.GetCrc16(this.cpuId)
      var data = '240706F802' + this.cpuId.slice(6, 7) + this.cpuId.slice(9, 11) + this.cpuId.slice(13) + crc16 + '00'
      window.external.WritePortData(data)
    },
    // 查询使用时长
    QueryUserTime () {
      window.external.WritePortData('2408010101')
    },
    // 清空使用时长
    ClearUserTime () {
      window.external.WritePortData('2409010101')
    },
    // 设置产品设备号
    SetSn () {
      var time = new Date()
      // 年
      var fullYear = '' + time.getFullYear()
      var myYear = fullYear.slice(2)
      // 月
      var month = time.getMonth() + 1
      var myMonth = '' + month
      if (month < 10) {
        myMonth = '0' + month
      }
      // 日
      var date = time.getDate()
      var myDate = '' + date
      if (date < 10) {
        myDate = '0' + date
      }
      // 处理流水号
      var snint = parseInt(this.sn)
      var snstr = ''
      if (snint < 10) {
        snstr = '000' + snint
      } else if (snint < 100) {
        snstr = '00' + snint
      } else if (snint < 1000) {
        snstr = '0' + snint
      } else {
        snstr = '' + snint
      }
      var data = '240B0602' + myYear + myMonth + myDate + snstr + '00'
      window.external.WritePortData(data)
    },
    // 接收串口数据并处理
    RecvDataFromWinForm (data) {
      if (data.indexOf('$,') != -1 && data.indexOf(',%') != -1) {
        var dataList = data.split(',')
        var dataType = dataList[1]
        if (dataType == '1') {
          var rvType = dataList[2]
          if (rvType == '1') {
            this.portData = '设置用户ID，指令收到'
          }
          if (rvType == '2') {
            this.portData = '设置用户初始屈光度，指令收到'
          }
          if (rvType == '9') {
            this.portData = '清空用户使用时长，指令收到'
          }
          if (rvType == '10') {
            this.portData = '机构检测，指令收到'
          }
          if (rvType == '11') {
            this.portData = '设置产品设备号，指令收到'
          }
          if (rvType == '12') {
            this.portData = '语音检测，指令收到'
          }
        }
        if (dataType == '2') {
          this.deviceUserId = dataList[2] + dataList[3] + dataList[4] + dataList[5]
        }
        if (dataType == '3') {
          this.portDataDianJi1 = dataList[2]
          this.portDataDianJi2 = dataList[3]
          this.portDataDianJi3 = dataList[4]
          this.portDataDianJi4 = dataList[5]
        }
        if (dataType == '4') {
          this.portDataLight = dataList[3]
          this.portDataDistance = dataList[2]
        }
        if (dataType == '6') {
          this.portDataCurRangeIndex = dataList[2]
        }
        if (dataType == '7') {
          this.cpuId = dataList[2] + dataList[3] + dataList[4] + dataList[5] + dataList[6] + dataList[7] + dataList[8]
        }
        if (dataType == '8') {
          this.aCodeResult = dataList[2]
        }
        if (dataType == '9') {
          this.userTime = dataList[2]
          this.deviceTime = dataList[3]
        }
        if (dataType == '10') {
          this.deviceDiopter = dataList[2]
        }
      } else if (data.indexOf('Vol:') != -1) {
        this.vol = data
      } else {
        this.portData = data
      }
    },
    /// /////
    RslEvLogin: function () {
      var that = this
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        timestamp: timestamp,
        loginname: 'RslEvSG01',
        password: '80824463'
      }
      axios.post(Vue.prototype.global.Url_RslEvLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            // 保存数据
            localStorage.setItem('Useriderp', response.data.Useriderp)
            localStorage.setItem('Roletype', response.data.Roletype)
            localStorage.setItem('Authtokenrslev', response.data.Authtokenrslev)
            alert('' + response.data.Useriderp + ';' + response.data.Roletype + ';' + response.data.Authtokenrslev)
            // 跳转
            // that.$router.push('/Home')
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    RslEvGetUser: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        glassuserid: '17499',
        loginname: ''
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignRslEv(data)
      axios.post(Vue.prototype.global.Url_RslEvGetUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            alert(response.data.Name)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    RslEvLoginPrint: function () {
      var Useriderp = localStorage.getItem('Useriderp')
      var Roletype = localStorage.getItem('Roletype')
      var Authtokenrslev = localStorage.getItem('Authtokenrslev')
      alert('' + Useriderp + ';' + Roletype + ';' + Authtokenrslev)
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
